import React, { useEffect } from 'react';
import { Breadcrumb, Layout, Menu } from '@arco-design/web-react';
import { Stack } from '../Stack';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

interface FrameProps {
    title: string;
    breadcrumb?: React.ReactElement;
    primaryAction?: React.ReactElement;
    children: React.ReactElement;
}

export default function Frame({
                                  children,
                                  title,
                                  primaryAction,
                                  breadcrumb,
                              }: FrameProps) {
    useEffect(() => {
    }, []);

    return (
        <Layout>
            <Header style={{ padding: '0 20px', backgroundColor: '#000000' }}>
                <Stack distribution='equalSpacing' alignment='center'>
                    <h1 style={{ color: 'white', margin: '15px 0' }}>Templater</h1>

                    <div style={{ marginTop: 10 }}>
                        <Stack distribution='equalSpacing' alignment='center' />
                    </div>
                </Stack>
            </Header>
            <Layout>
                <Layout style={{ padding: 24 }}>
                    <Stack vertical>
                        {breadcrumb && (
                            <Breadcrumb>
                                <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                            </Breadcrumb>
                        )}

                        <Stack distribution='equalSpacing' alignment='center'>
                            <Stack.Item>
                                <h2>
                                    <strong>{title}</strong>
                                </h2>
                            </Stack.Item>
                            <Stack.Item>{primaryAction}</Stack.Item>
                        </Stack>

                        <Stack.Item>
                            <Content
                                style={{
                                    padding: 24,
                                    margin: 0,
                                    backgroundColor: '#fff',
                                }}
                            >
                                {children}
                            </Content>
                        </Stack.Item>
                    </Stack>
                </Layout>
            </Layout>
        </Layout>
    );
}
